import { render, staticRenderFns } from "./InsAboutUs.vue?vue&type=template&id=fd93ede8&scoped=true"
import script from "./InsAboutUs.vue?vue&type=script&lang=ts"
export * from "./InsAboutUs.vue?vue&type=script&lang=ts"
import style0 from "./InsAboutUs.vue?vue&type=style&index=0&id=fd93ede8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd93ede8",
  null
  
)

export default component.exports